import React, { useContext, useEffect, useState } from "react";
import { StyleSheet, TouchableOpacity, TextInput } from "react-native";
import { Button } from "react-native-paper";
import Icon from "react-native-vector-icons/FontAwesome5";
import { ReadOnlyProps } from "../../../utils/templates";
import DeviceOrientationContext from "../../../components/context/DeviceOrientationContext";
import { exportDataToExcelMultiSheet } from "./exportDataToExcelMultiSheet";
import { View } from "../../../components/shared/Themed";
import { Text } from "react-native";

// Props
interface Props {
  titleName: string;
  isSmallDevice?: boolean;
  isMobileDevice?: boolean;
  isEditable?: boolean;
  ref?: any;
  isResetFields?: boolean;
  handleSearch: (searchText: string) => void;
  setRefresh: (event: any) => void;
  setEditable?: (event: any) => void;
  padding?: boolean;
  disableTitle?: boolean;
  noBorder?: boolean;

  // Export
  dataToExport?: Array<any>;
  fileName?: string;
  sheetNames?: string[];
  t: any;
  advanced?: boolean;
  navigateToOrder?: any;
}

export const LabelBannerWithMultiExport = (props: ReadOnlyProps<Props>) => {
  const { isSmallDevice, isMobileDevice } = useContext(
    DeviceOrientationContext,
  );
  const [_searchText, setSearchText] = useState<string>("");

  useEffect(() => {
    if (_searchText.trim().length === 0) props.handleSearch("");
    else props.handleSearch(_searchText.trim());
  }, [_searchText]);

  useEffect(() => {
    if (props.isResetFields) setSearchText("");
  }, [props.isResetFields]);

  const submitSearch = () => props.handleSearch(_searchText.trim());

  const isExportAllowed = () =>
    !isSmallDevice &&
    !isMobileDevice &&
    props.dataToExport &&
    props.dataToExport.length > 0;

  const handleMultiExport = () => {
    if (!props.dataToExport || props.dataToExport.length === 0) return;

    exportDataToExcelMultiSheet(
      props.dataToExport,
      props.fileName || "OrderTracker",
      props.sheetNames || ["Orders", "Factory Orders", "Shipments"],
      props.t,
    );
  };

  return (
    <View>
      <View style={[styles.container, props.noBorder && { borderWidth: 0 }]}>
        <View
          style={[
            styles.headerRow,
            {
              backgroundColor: props.isEditable ? "#fece85" : "white",
              paddingHorizontal: props.padding ? 35 : 0,
            },
            props.noBorder && { borderWidth: 0 },
          ]}
        >
          {!isSmallDevice &&
            !isMobileDevice &&
            props.disableTitle == undefined && (
              <Text style={[styles.title, { width: "80%" }]}>
                {props.titleName}
              </Text>
            )}

          {props.isEditable && (
            <Button
              mode="contained"
              uppercase={false}
              onPress={() => props.setEditable?.(!props.isEditable)}
              color="grey"
              style={{ marginRight: "1%" }}
            >
              Cancel
            </Button>
          )}

          <View style={styles.iconGroup}>
            {props.advanced && props.navigateToOrder && (
              <TouchableOpacity
                style={styles.iconButton}
                onPress={() => props.navigateToOrder(null, "advanced_search")}
                activeOpacity={0.7}
              >
                <Icon name="search" size={16} color="#000080" />
              </TouchableOpacity>
            )}

            <TouchableOpacity
              style={styles.iconButton}
              onPress={() => {
                setSearchText("");
                props.setRefresh(true);
              }}
              activeOpacity={0.7}
            >
              <Icon name="sync" size={16} color="#000080" />
            </TouchableOpacity>
          </View>

          <TextInput
            ref={props.ref}
            style={[styles.input, { width: !props.isMobileDevice ? 250 : 180 }]}
            onChangeText={setSearchText}
            value={_searchText || ""}
            placeholder="Type your search"
            onSubmitEditing={() =>
              _searchText.trim().length >= 3 && submitSearch()
            }
          />

          <View style={{ flexDirection: "row" }}>
            <Button
              icon="magnify"
              disabled={_searchText.trim().length < 3}
              mode="contained"
              uppercase={false}
              onPress={submitSearch}
              color={props.isEditable ? "#7F00FF" : "#b22442"}
              style={isExportAllowed() ? styles.searchBtn : styles.margin_10PX}
              contentStyle={styles.buttonContent}
            />

            {isExportAllowed() && (
              <Button
                icon="file-excel"
                mode="contained"
                uppercase={false}
                onPress={handleMultiExport}
                color="rgb(47, 149, 220)"
                style={styles.excelBtn}
                contentStyle={styles.buttonContent}
              />
            )}
          </View>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    borderWidth: 0.1,
    width: "100%",
    borderRadius: 2,
    borderColor: "#F5F5F5",
  },
  headerRow: {
    flexDirection: "row",
    width: "100%",
    height: 50,
    alignItems: "center",
    justifyContent: "center",
    borderBottomWidth: 1,
    borderColor: "darkgrey",
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
    marginLeft: "2%",
  },
  input: {
    height: 35,
    borderColor: "#F5F5F5",
    margin: 12,
    borderWidth: 1,
    borderRadius: 5,
    padding: 10,
  },
  margin_10PX: { marginRight: "10px" },
  searchBtn: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    padding: "1%",
  },
  excelBtn: {
    marginRight: "10px",
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  buttonContent: {
    paddingTop: "10%",
    paddingBottom: "10%",
    paddingLeft: "25%",
  },
  iconGroup: {
    flexDirection: "row",
    alignItems: "center",
    marginHorizontal: 8,
  },

  iconButton: {
    padding: 8,
    marginHorizontal: 4,
    borderRadius: 20,
    backgroundColor: "#F5F5F5",
    justifyContent: "center",
    alignItems: "center",
  },
});
